module.exports = __webpack_public_path__ + "static/media/3XL.21ffb503.jpg";